import { Polyline } from "react-leaflet";
import type { TrackPoint } from "../map/types";

/**
 * The path an aircraft has already flown, from the server's downsampled history.
 *
 * Routinely short or absent, and that is not a bug: points are only recorded while somebody is
 * watching (the poller idles otherwise), so an aircraft that just came into view genuinely has
 * no past here. Drawn dimmer than the projection, because where something has been is context
 * and where it is going is the question.
 */
export default function TrailLayer({ points }: { points: TrackPoint[] }) {
  if (points.length < 2) return null;
  return (
    <Polyline
      positions={points.map((p) => [p.lat, p.lon] as [number, number])}
      pathOptions={{ color: "#8ea0c0", weight: 2, opacity: 0.55 }}
      interactive={false}
    />
  );
}
